import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "survey-progress-bar-container" }
const _hoisted_3 = { class: "progress-text" }
const _hoisted_4 = { class: "current-count-text" }

import ProgressBar from '@/components/PrimeVue/ProgressBar.vue'

interface Props {
    currentQuestion: number
    remainingQuestionCount?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SurveyProgressBar',
  props: {
    currentQuestion: {},
    remainingQuestionCount: {}
  },
  setup(__props: any) {

const props = __props
const getCurrentQuestion = () => {
    return props.currentQuestion + 1
}
const getMaxQuestionCount = () => {
    return props.remainingQuestionCount + getCurrentQuestion()
}
const getProgress = () => {
    let max = getMaxQuestionCount()
    let current = getCurrentQuestion()
    if (max < 1 || current < 1) {
        return 0
    }
    return (current / max) * 100
}

return (_ctx: any,_cache: any) => {
  return (getCurrentQuestion() > 1 || props.remainingQuestionCount > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "survey-progress-bar-header",
        role: "region",
        "aria-live": "polite",
        "aria-label": `Survey progress: ${Math.round(getProgress())}% complete. Question ${getCurrentQuestion()} of ${getMaxQuestionCount() || '…'}`
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, "Question " + _toDisplayString(getCurrentQuestion()), 1),
            _createTextVNode(" of " + _toDisplayString(getMaxQuestionCount()), 1)
          ]),
          _createVNode(ProgressBar, {
            value: getProgress(),
            "show-value": false,
            "bar-color": "#006cff",
            "background-color": "#ddd",
            class: "survey-progress-bar",
            "aria-label": `Survey progress: ${Math.round(getProgress())}% complete`
          }, null, 8, ["value", "aria-label"])
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})